// extracted by mini-css-extract-plugin
export default {"dashboard__view":"DashboardPage_dashboard__view__uWAxE","dashboard__view__needs":"DashboardPage_dashboard__view__needs__X4eLQ"};